'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonAction", "isMABExperiment", "mabExperimentIsMasterLive", "mabExperimentIsStarted", "mabExperimentVariantsSize", "isReadOnlyMode", "fetchContent", "fetchHardSavedContent", "hasExceededContentTypeLimit", "hasExceededMlangPagesLimit", "controlCenterUrl", "showOnboardingTourQuitModal", "startMABExperiment", "togglePublishModalOpen", "togglePublishOptionsModalOpen", "isUserJitad", "unpublishEnabled", "canSchedule", "publishImmediately", "updatePublishImmediately", "patagoniaPublishType", "errors", "warnings", "isTestVariation", "testPrimaryName", "isBlogListingPage", "buttonTextKey", "lockedButtonTextKey", "hasStagingDomain", "unpublish", "loadingFailed"];
import { connect, useSelector } from 'react-redux';
import { Fragment, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import UIButton from 'UIComponents/button/UIButton';
import MABPublishConfirmModal from 'ContentEditorUI/components/publishing/modals/MABPublishConfirmModal';
import { getIsSavePermanentlyDisabled } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getCannotPublishOnActiveDomainReason, getLockedPublishButtonTextKey } from 'page-editor-ui/redux/selectors/pagePublishSelectors';
import { getHasPermissionsToPublish, getIsPublishEnabled, getPublishButtonAction, getPublishButtonTextKey } from 'page-editor-ui/redux/selectors/pagePublishSelectors';
import { getHasExceededMlangPagesLimit } from 'page-editor-ui/redux/selectors/pageLimitSelectors';
import { updatePublishImmediately as updatePublishImmediatelyAction } from 'ContentEditorUI/redux/actions/publishActions';
import { unpublish as unpublishAction } from 'page-editor-ui/redux/actions/pagePublishActions';
import { getDashboardUrl } from 'page-editor-ui/redux/selectors/urlSelectors';
import Raven from 'raven-js';
import { getPublishDate, getShouldPublishImmediately } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getPageSettingsErrors } from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
import { getPublishNoun, getPatagoniaPublishType, getIsPublishInProgress, getIsPublishFailed } from 'ContentEditorUI/redux/selectors/publishSelectors';
import { updateFocusedItem as updateFocusedItemAction } from 'page-editor-ui/redux/actions/pageFocusActions';
import { getIsMABExperiment, getIsMabVariant, getMABExperimentIsMasterLive, getMABExperimentIsStarted, getMABExperimentPrimayVariantName, getMABExperimentVariantsSize } from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import { startMABExperiment as startMABExperimentAction } from 'page-editor-ui/redux/actions/mabExperimentActions';
import { togglePublishModalOpen as togglePublishModalOpenAction, togglePublishOptionsModalOpen as togglePublishOptionsModalOpenAction } from 'ContentEditorUI/redux/actions/appActions';
import { getIframeReady, getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getHasSaveError } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { fetchContent as fetchContentAction, fetchHardSavedContent as fetchHardSavedContentAction } from 'ContentEditorUI/redux/actions/contentActions';
import { PAGES_API_BASE_URL } from 'page-editor-ui/Constants';
import { getIsBlogListingPage, getIsSitePage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { getContextActiveDomainAsMap, getHasStagingDomain } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import BaymaxPublishButton from 'ContentEditorUI/components/shared/BaymaxPublishButton';
import { getIsUnpublishEnabled } from '../redux/selectors/pagePublishSelectors';
import { getHasContentTypeLimitReducerAndExceededLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
import { getNumberOfPagesOverLimit, getPageLimitValue } from '../redux/selectors/pageLimitSelectors';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { showOnboardingTourQuitModal as showOnboardingTourQuitModalAction } from 'ContentEditorUI/redux/actions/onboardingTourStateActions';
import { getIsUserJitad } from 'ContentEditorUI/redux/selectors/authSelectors';
import UIIcon from 'UIComponents/icon/UIIcon';
import EditorApprovalButtons from 'ContentEditorUI/components/approvals/EditorApprovalButtons';
import { getPageErrorLabels, getPageWarningLabels } from '../redux/selectors/pageWarningsAndSuggestionsSelectors';
import WarningsAndSuggestionsPanel from 'ContentEditorUI/components/modals/WarningsAndSuggestionsPanel';
import { getAbMasterName, getIsABVariant } from 'ContentEditorUI/redux/selectors/abTestSelectors';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { getPageUsageLimitExceededLockedPulishButtonUpgradeModalKey } from '../redux/selectors/downgradeSelectors';
import usePublishAction from '../hooks/usePublishAction';
import { getCanSchedule } from 'page-editor-ui/redux/selectors/authSelectors';
import useAudienceAccessType from 'page-editor-ui/hooks/useAudienceAccessType';
import { getPageSettingsFullUrl } from 'page-editor-ui/redux/selectors/pageSettingsSelectors';
import AudienceAccessTypes from 'ContentUtils/constants/AudienceAccessTypes';
import UseCaseTourCompleteModal from '../components/UseCaseTourCompleteModal';
import { isFromPaymentsGuide, getOnboardingToursTask } from 'payments-post-enroll-local-storage-lib/data/onboardingTours';
import { markActionComplete } from 'user-context/onboarding';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => {
  return {
    contextActiveDomain: getContextActiveDomainAsMap(state),
    buttonAction: getPublishButtonAction(state),
    buttonTextKey: getPublishButtonTextKey(state),
    lockedButtonTextKey: getLockedPublishButtonTextKey(state),
    isMABExperiment: getIsMABExperiment(state),
    isReadOnlyMode: getIsReadOnlyMode(state),
    publishNoun: getPublishNoun(state),
    mabExperimentIsMasterLive: getMABExperimentIsMasterLive(state),
    cannotPublishOnDomainReason: getCannotPublishOnActiveDomainReason(state),
    mabExperimentIsStarted: getMABExperimentIsStarted(state),
    mabExperimentVariantsSize: getMABExperimentVariantsSize(state),
    patagoniaPublishType: getPatagoniaPublishType(state),
    permanentlyDisabled: getIsSavePermanentlyDisabled(state),
    publishAllowed: getHasPermissionsToPublish(state),
    publishDate: getPublishDate(state),
    publishImmediately: getShouldPublishImmediately(state),
    settingsErrors: getPageSettingsErrors(state),
    iframeReady: getIframeReady(state),
    hasSaveError: getHasSaveError(state),
    loadingFailed: getIsPublishFailed(state),
    publishEnabled: getIsPublishEnabled(state),
    unpublishEnabled: getIsUnpublishEnabled(state),
    controlCenterUrl: getDashboardUrl(state),
    hasExceededContentTypeLimit: getHasContentTypeLimitReducerAndExceededLimit(state),
    hasExceededMlangPagesLimit: getHasExceededMlangPagesLimit(state),
    numberOfPagesOverLimit: getNumberOfPagesOverLimit(state),
    pageLimit: getPageLimitValue(state),
    isSitePage: getIsSitePage(state),
    isUserJitad: getIsUserJitad(state),
    canSchedule: getCanSchedule(state),
    errors: getPageErrorLabels(state),
    warnings: getPageWarningLabels(state),
    isTestVariation: getIsABVariant(state) || getIsMabVariant(state),
    testPrimaryName: getAbMasterName(state) || getMABExperimentPrimayVariantName(state),
    isBlogListingPage: getIsBlogListingPage(state),
    hasStagingDomain: getHasStagingDomain(state)
  };
};
const mapDispatchToProps = {
  startMABExperiment: startMABExperimentAction,
  updateFocusedItem: updateFocusedItemAction,
  updatePublishImmediately: updatePublishImmediatelyAction,
  togglePublishModalOpen: togglePublishModalOpenAction,
  togglePublishOptionsModalOpen: togglePublishOptionsModalOpenAction,
  unpublish: unpublishAction,
  fetchContent: fetchContentAction,
  fetchHardSavedContent: fetchHardSavedContentAction,
  showOnboardingTourQuitModal: showOnboardingTourQuitModalAction
};
const PatagoniaPagePublishButtonContainer = _ref => {
  let {
      buttonAction,
      isMABExperiment,
      mabExperimentIsMasterLive,
      mabExperimentIsStarted,
      mabExperimentVariantsSize,
      isReadOnlyMode,
      fetchContent,
      fetchHardSavedContent,
      hasExceededContentTypeLimit,
      hasExceededMlangPagesLimit,
      controlCenterUrl,
      showOnboardingTourQuitModal,
      startMABExperiment,
      togglePublishModalOpen,
      togglePublishOptionsModalOpen,
      isUserJitad,
      unpublishEnabled,
      canSchedule,
      publishImmediately,
      updatePublishImmediately,
      patagoniaPublishType,
      errors,
      warnings,
      isTestVariation,
      testPrimaryName,
      isBlogListingPage,
      buttonTextKey,
      lockedButtonTextKey,
      hasStagingDomain,
      unpublish,
      loadingFailed
    } = _ref,
    passThroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [mabConfirmModalOpen, setMabConfirmModalOpen] = useState(false);
  const [unpublishConfirmModalOpen, setUnpublishConfirmModalOpen] = useState(false);
  const [isWarningsAndSuggestionsPanelOpen, setIsWarningsAndSuggestionsPanelOpen] = useState(false);
  const [showUseCaseTourCompleteModal, setShowUseCaseTourCompleteModal] = useState(false);
  const pageSettingsFullUrl = useSelector(getPageSettingsFullUrl);
  const publishPage = usePublishAction();
  const audienceAccessType = useAudienceAccessType();
  const isPublishInProgress = useSelector(getIsPublishInProgress);
  const shouldShowLoadingButton = isPublishInProgress;
  const publishCallback = useCallback(() => {
    if (isFromPaymentsGuide()) {
      /**
       * For Payments Activation tours.
       * See https://product.hubteam.com/docs/commerce-pay-activation-fe-handbook/docs/userGuideOnboarding/post031.html
       *
       * This will make the tour sucess modal show up once websites are published.
       */
      const onboardingToursTask = getOnboardingToursTask();
      if (onboardingToursTask) {
        setShowUseCaseTourCompleteModal(true);
        markActionComplete(onboardingToursTask, {
          showTaskCompletionModal: false
        }).catch(error => Raven.captureException(error));
      }
    }
    if (isMABExperiment && !mabExperimentIsStarted) {
      setMabConfirmModalOpen(true);
    } else {
      updatePublishImmediately(true);
      if (audienceAccessType === AudienceAccessTypes.ALL) {
        // Passing true prevents the user from being redirected upon a successful publish.
        publishPage(true);
      } else {
        togglePublishModalOpen(true);
      }
    }
  }, [isMABExperiment, mabExperimentIsStarted, togglePublishModalOpen, updatePublishImmediately, publishPage, audienceAccessType]);
  const onUnpublishSuccess = useCallback(() => {
    setUnpublishConfirmModalOpen(false);
    fetchContent({
      baseUrl: PAGES_API_BASE_URL
    });
    fetchHardSavedContent({
      baseUrl: PAGES_API_BASE_URL
    });
    FloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.message"
      }),
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.success.text"
      }),
      type: 'success'
    });
  }, [fetchContent, fetchHardSavedContent]);
  const handleUnpublish = () => {
    unpublish({
      skipPublishRedirect: true,
      onPublishSuccess: onUnpublishSuccess
    });
  };
  const closeMABPublishConfirmModal = useCallback(() => {
    setMabConfirmModalOpen(false);
  }, []);
  const publishMABConfirmModalCallback = useCallback(() => {
    startMABExperiment();
    setMabConfirmModalOpen(false);
  }, [startMABExperiment]);
  const openSchedulePublishOptionsModal = useCallback(() => {
    togglePublishOptionsModalOpen(true);
  }, [togglePublishOptionsModalOpen]);
  const upgradeModalKey = useSelector(getPageUsageLimitExceededLockedPulishButtonUpgradeModalKey);
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeModalKey);
  if (hasExceededMlangPagesLimit) {
    passThroughProps.tooltipOverride = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "mLang.sitePageLimitExceededError",
      options: {
        controlCenterUrl
      }
    });
  } else if (isReadOnlyMode) {
    passThroughProps.tooltipOverride = /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'app.readOnly.publishButton.pages'
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(EditorApprovalButtons, {
      errorsAndWarnings: [...errors, ...warnings],
      onOpenWarningsAndSuggestionsPanel: () => setIsWarningsAndSuggestionsPanelOpen(true),
      isTestVariation: isTestVariation,
      testVariationDisabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "approvals.testVariationRequestApprovalDisabledTooltip",
        options: {
          name: testPrimaryName
        }
      }),
      buttonSize: "sm",
      dropdownProps: {
        buttonSize: 'sm'
      },
      extraButtons: unpublishEnabled && /*#__PURE__*/_jsx(UIButton, {
        onClick: () => setUnpublishConfirmModalOpen(true),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editor.publishing.unpublish"
        })
      }),
      children: [/*#__PURE__*/_jsx(UITourStep, {
        tourKey: "free-lp-onboarding-parent",
        stepKey: "publish",
        showSteps: true,
        placement: "bottom left",
        content: {
          header: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("h4", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "freeLPTour.parent.publish.header"
              })
            }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
              onClick: showOnboardingTourQuitModal,
              style: {
                marginTop: '-4px'
              }
            })]
          }),
          body: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "freeLPTour.parent.publish.body"
          })
        },
        children: /*#__PURE__*/_jsx(BaymaxPublishButton, Object.assign({}, passThroughProps, {
          unpublish: unpublish,
          buttonTextKey: hasExceededContentTypeLimit ? lockedButtonTextKey : buttonTextKey,
          actions: canSchedule && !isBlogListingPage && !hasExceededContentTypeLimit && !hasStagingDomain ? [{
            label: /*#__PURE__*/_jsxs(Fragment, {
              children: [/*#__PURE__*/_jsx(UIIcon, {
                name: "time"
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: `editor.publishing.schedule.${patagoniaPublishType}`
              })]
            }),
            onClick: openSchedulePublishOptionsModal
          }] : [],
          buttonAction: buttonAction,
          publishCallback: publishCallback,
          onUnpublishSuccess: onUnpublishSuccess,
          isUserJitad: isUserJitad,
          unpublishEnabled: unpublishEnabled,
          errors: errors,
          warnings: warnings,
          publishImmediately: publishImmediately,
          updatePublishImmediately: updatePublishImmediately,
          isLocked: hasExceededContentTypeLimit,
          onClickLocked: openUpgradeModal,
          loading: shouldShowLoadingButton,
          loadingFailed: loadingFailed,
          shouldUseOneClickPublish: true
        }))
      }), mabConfirmModalOpen && /*#__PURE__*/_jsx(MABPublishConfirmModal, {
        dismissCallback: closeMABPublishConfirmModal,
        isMasterLive: mabExperimentIsMasterLive,
        numberOfVariants: mabExperimentVariantsSize,
        publishCallback: publishMABConfirmModalCallback
      })]
    }), unpublishConfirmModalOpen && /*#__PURE__*/_jsx(UIConfirmModal, {
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.message"
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.description"
      }),
      confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "editor.publishing.unpublish"
      }),
      onConfirm: handleUnpublish,
      rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "unpublishModal.cancel"
      }),
      onReject: () => setUnpublishConfirmModalOpen(false),
      size: "auto"
    }), isWarningsAndSuggestionsPanelOpen && /*#__PURE__*/_jsx(WarningsAndSuggestionsPanel, {
      errors: errors,
      warnings: warnings,
      onClose: () => setIsWarningsAndSuggestionsPanelOpen(false),
      onIssueClick: updateFocusedItemAction,
      publishButtonCallback: publishCallback,
      publishButtonTextKey: buttonTextKey,
      disabledPublishButtonTooltipText: "warningsAndSuggestionsPanel.disabledPagePublishTootlip_jsx"
    }), showUseCaseTourCompleteModal && /*#__PURE__*/_jsx(UseCaseTourCompleteModal, {
      onClose: () => {
        setShowUseCaseTourCompleteModal(false);
      },
      websiteLink: pageSettingsFullUrl
    })]
  });
};
PatagoniaPagePublishButtonContainer.propTypes = {
  buttonAction: PropTypes.string,
  fetchContent: PropTypes.func.isRequired,
  fetchHardSavedContent: PropTypes.func.isRequired,
  isReadOnlyMode: PropTypes.bool.isRequired,
  togglePublishModalOpen: PropTypes.func.isRequired,
  togglePublishOptionsModalOpen: PropTypes.func.isRequired,
  startMABExperiment: PropTypes.func.isRequired,
  isMABExperiment: PropTypes.bool.isRequired,
  mabExperimentIsMasterLive: PropTypes.bool,
  mabExperimentIsStarted: PropTypes.bool,
  mabExperimentVariantsSize: PropTypes.number,
  hasExceededContentTypeLimit: PropTypes.bool.isRequired,
  hasExceededMlangPagesLimit: PropTypes.bool.isRequired,
  controlCenterUrl: PropTypes.string.isRequired,
  numberOfPagesOverLimit: PropTypes.number,
  pageLimit: PropTypes.number,
  showOnboardingTourQuitModal: PropTypes.func.isRequired,
  isSitePage: PropTypes.bool.isRequired,
  isUserJitad: PropTypes.bool.isRequired,
  unpublish: PropTypes.func.isRequired,
  unpublishEnabled: PropTypes.bool.isRequired,
  canSchedule: PropTypes.bool.isRequired,
  updatePublishImmediately: PropTypes.func.isRequired,
  publishImmediately: PropTypes.bool.isRequired,
  patagoniaPublishType: PropTypes.string,
  errors: PropTypes.array.isRequired,
  warnings: PropTypes.array.isRequired,
  isTestVariation: PropTypes.bool.isRequired,
  testPrimaryName: PropTypes.string,
  isBlogListingPage: PropTypes.bool.isRequired,
  buttonTextKey: PropTypes.string.isRequired,
  lockedButtonTextKey: PropTypes.string.isRequired,
  hasStagingDomain: PropTypes.bool.isRequired,
  loadingFailed: PropTypes.bool.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(PatagoniaPagePublishButtonContainer);